import React, { Component, Fragment } from 'react'
import AutoInput from '../containers/AutoInput'
import withValues from '../hocs/withValues'
import { getValue } from '../utils/models'

class Role extends Component {

    render() {
        return (
            <Fragment>
                <AutoInput
                    form={this.props.form}
                    model={'role'}
                    attribute={'name'}
                    value={getValue(this.props.values, 'name')}
                />
                <AutoInput
                    form={this.props.form}
                    model={'role'}
                    attribute={'permissions'}
                    value={getValue(this.props.values, 'permissions')}
                    showAdd={false}
                />
            </Fragment>
        )
    }

}

export default withValues(Role)


// WEBPACK FOOTER //
// ./src/forms/Role.js